import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(document.getElementById("root"));
const domain = process.env.REACT_APP_AUTH0_DOMAIN;

root.render(
  //     audience="http://localhost:44442"
  <Auth0Provider
    domain="dev-tuze2dvpl0ek404.eu.auth0.com"
    clientId="MKDzR3TVARewXS1tCc3UgWvb21MFIXov"
    redirectUri={window.location.origin}
    scope="read:messages"
    audience={`https://${domain}/api/v2/`}
  >   
    <App />
  </Auth0Provider>
);